import { PageHeader } from "antd";
import LayoutCss from "../../../layout/layout.module.scss";
import { RecruiterGoalsContainer } from "./recruiterGoalsContainer/recruiterGoalsContainer";

export const RecruiterGoals = () => {
  return (
    <>
      <PageHeader
        ghost={false}
        title="Recruiter Goals"
        className={LayoutCss.appPageHeader}
      />
      <RecruiterGoalsContainer />
    </>
  );
};
